document.addEventListener("DOMContentLoaded", function () {
  const quantityInputs = document.querySelectorAll('input[name="properties[Quantity]"]');
  const container = document.querySelector('.option-custom-swatchs');
  const basePrice = container ? parseFloat(container.dataset.prices) || 0 : 0;
  const totalPriceElement = document.querySelector('.product-total-price');

  // 新增：获取按钮区域元素
  const submitButton = document.querySelector('.product-form__submit');
  const contactButton = document.querySelector('.product-up-contact');

  function handleQuantityChange(input) {
    const value = input.value;
    const label = input.nextElementSibling;
    if (!label) return;

    // 获取总价元素
    const zongEl = label.querySelector(".swatchs-label__zong");
    let zongPrice = 0;
    let displayPrice = "0";

    if (zongEl) {
      const zongPriceText = zongEl.getAttribute("zong-price");
      
      // 判断 zong-price 是否存在
      const hasZongPrice = zongPriceText !== null && zongPriceText !== "";

      // 控制按钮显示状态
      if (hasZongPrice) {
        zongPrice = parseFloat(zongPriceText) - basePrice;
        displayPrice = zongEl.textContent.trim();

        submitButton?.classList.remove('hidden');
        contactButton?.classList.add('hidden');
      } else {
        submitButton?.classList.add('hidden');
        contactButton?.classList.remove('hidden');
      }
    }

    // 更新显示总价
    if (totalPriceElement) {
      totalPriceElement.textContent = displayPrice;
    }

    // 获取单位价格
    const unitPriceEl = label.querySelector(".swatchs-label_price");
    const dataPrice = unitPriceEl ? unitPriceEl.dataset.price || "0" : "0";

    // 更新两个隐藏 input 值
    ymqJq('.bulk_price-option input')
      .val(value)
      .data('price', zongPrice)
      .change();

    ymqJq('.unit-prices input')
      .val(dataPrice)
      .data('price', 0)
      .change();
  }

  // 绑定事件
  quantityInputs.forEach(function (input) {
    input.addEventListener("change", function () {
      handleQuantityChange(this);
    });
  });

  // 页面初始默认选中执行
  setTimeout(function () {
    const defaultCheckedInput = document.querySelector('input[name="properties[Quantity]"]:checked');
    if (defaultCheckedInput) {
      handleQuantityChange(defaultCheckedInput);
    }
  }, 1000);



const contactTriggers = document.querySelectorAll('.product-up-contact');
const contactPopupButton = document.querySelector('#ProductPopup-contact');

if (contactTriggers.length > 0 && contactPopupButton) {
  contactTriggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      contactPopupButton.click();
    });
  });
}

});
